import {Component, Inject, NgZone, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Equipment} from "../../../models/equipment";
import {Resource, ResourceType} from "../../../models/resource";
import {Paginator} from "../../../models/paginator";
import {ResourceManager} from "../../../services/resource-manager";

export interface ChooseResourceDialogData {
  equipment: Equipment;
  types: ResourceType[];
  rows: number;
  resource: Resource;
}

@Component({
  selector: 'app-choose-resource-dialog',
  templateUrl: './choose-resource-dialog.component.html',
  styleUrls: ['./choose-resource-dialog.component.scss']
})
export class ChooseResourceDialogComponent implements OnInit {

  paginator: Paginator<Resource>;
  resources: Resource[];

  constructor(
    private resourceManager: ResourceManager,
    public dialogRef: MatDialogRef<ChooseResourceDialogComponent>,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: ChooseResourceDialogData
  ) {
    this.paginator = new Paginator<Resource>({ pageSize: data.rows * 6 });
  }

  onNoClick(): void {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
  }

  onChooseCompleted(data: any) {
    this.ngZone.run(() => {
      this.dialogRef.close(data);
    });
  }

  async ngOnInit(): Promise<void> {
    this.paginator.onPageResults = (resources: Resource[]) => {
      this.resources = resources;
    }
    await this.resourceManager.getResources(this.data.equipment.id, this.paginator);
  }

  onResourceSelected(resource: Resource) {
    this.data.resource = resource;
  }

}
